import { render, staticRenderFns } from "./InlineEditableRichText.vue?vue&type=template&id=51f75b4d&scoped=true&"
import script from "./InlineEditableRichText.vue?vue&type=script&lang=js&"
export * from "./InlineEditableRichText.vue?vue&type=script&lang=js&"
import style0 from "./InlineEditableRichText.vue?vue&type=style&index=0&id=51f75b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f75b4d",
  null
  
)

export default component.exports